import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import type { ActionsObservable, Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { baseUrlSelector, projectIdSelector, selectedAccessTypeSelector } from '../../selectors';
import { projectAccessValueService } from '../../services';
import type { State } from '../../types';
import {
	fetchProjectAccessTypesFail,
	setProjectAccessType,
	type Action,
} from '../access-types/project-access-action-creators';

import { FETCH_PROJECT_ACCESS_VALUE } from './access-value-action-creators';

const epic: Epic<Action, State> = (
	action$: ActionsObservable<Action>,
	store: MiddlewareAPI<State>,
) =>
	action$.ofType(FETCH_PROJECT_ACCESS_VALUE).switchMap(() => {
		const state = store.getState();
		const baseUrl = baseUrlSelector(state);
		const projectId = projectIdSelector(state);
		const currentAccessType = selectedAccessTypeSelector(state);

		if (!projectId || currentAccessType) {
			return Observable.empty<never>();
		}

		return Observable.fromPromise(
			projectAccessValueService.getProjectAccessValue(baseUrl, projectId),
		)
			.map((response) =>
				setProjectAccessType({
					value: response.value,
					description: response.description,
					displayName: response.displayName,
					iconName: response.iconName,
				}),
			)
			.catch((e) => Observable.of(fetchProjectAccessTypesFail(e.message)));
	});

export default epic;
